export default __webpack_public_path__ + "static/media/veth2.d63eb1bb.svg";